import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalFilterSharedService {
  constructor() {}

  private subjectOpenGlobalFilterModal = new BehaviorSubject('');
  private subjectTeamUsersAddModal = new BehaviorSubject('');
  private subjectPrivilegedUsersAddModal = new BehaviorSubject('');

  private filteredUserTeamData = new BehaviorSubject<any>(null);

  private subjectApplyGlobalFilter = new BehaviorSubject(false);

  setSubjectOpenGlobalFilterModal(str: string) {
    this.subjectOpenGlobalFilterModal.next(str);
  }
  getSubjectOpenGlobalFilterModal(): Observable<string> {
    return this.subjectOpenGlobalFilterModal.asObservable();
  }

  setSubjectTeamUsersAddModal(str: string) {
    this.subjectTeamUsersAddModal.next(str);
  }
  getSubjectTeamUsersAddModal(): Observable<string> {
    return this.subjectTeamUsersAddModal.asObservable();
  }

  setSubjectPrivilegedUsersAddModal(privilegedUsers: any) {
    this.subjectPrivilegedUsersAddModal.next(privilegedUsers);
  }
  getSubjectPrivilegedUsersAddModal(): Observable<any> {
    return this.subjectPrivilegedUsersAddModal.asObservable();
  }

  setFilteredUserTeamData(userTeamData: any) {
    this.filteredUserTeamData.next(userTeamData);
  }

  getFilteredUserTeamData(): Observable<string> {
    return this.filteredUserTeamData.asObservable();
  }

  setSubjectApplyGlobalFilter(flag: boolean) {
    this.subjectApplyGlobalFilter.next(flag);
  }

  getSubjectApplyGlobalFilter(): Observable<boolean> {
    return this.subjectApplyGlobalFilter.asObservable();
  }
}
